import { Typography } from '@mui/material';
import cn from 'classnames';
import React, { ReactNode } from 'react';

import Loader from '../Loader';

interface Props {
  children: ReactNode;
  isFullHeight?: boolean;
  isError?: boolean;
  isLoading: boolean;
}

export const LoadingError = ({ isLoading, children, isFullHeight = true, isError = false }: Props) => (
  <>
    {isLoading ? (
      <div className={cn('flex items-center justify-center', { 'h-screen': isFullHeight })}>
        <Loader progress={undefined} />
      </div>
    ) : isError ? (
      <div className={cn('flex items-center justify-center', { 'h-screen': isFullHeight })}>
        <Typography className="text-white-smoke">Ops! Something went wrong... Please, try reload the page.</Typography>
      </div>
    ) : (
      <>{children}</>
    )}
  </>
);
